import { Record } from 'immutable';

export const CurrencyRecord = Record({
  id: undefined,
  symbol: ''
});
